import Footer from "../components/Footer";
import Header from "../components/Header";
import AboutUs from "./AboutUs";
import Career from "./Career";
import Dasboard from "./Dashboard";
import Licenses from "./Licenses";
import OurTeam from "./OurTeam";
import Services from "./Services";

const MainPage = () => {
  return (
    <div>
      <Header />
      <Dasboard />
      <AboutUs />
      <Services />
      <Licenses />
      <OurTeam />
      <Career />
      <Footer />
    </div>
  );
};

export default MainPage;
